import {ModuleWithProviders, NgModule} from '@angular/core';
import {TEXT_ACT} from './text-act-tokens';
import {TEXT_ACTINGS} from './text-actings';

/**
 * 단어 변조 모듈
 */
@NgModule()
export class TextActModule {
	/**
	 * 단어 변조 모듈 설정
	 *
	 * @example 아이콘 변경
	 * ```ts
	 * @NgModule({
	 *     imports: [
	 *         TextActModule.forRoot({
	 *         		create: 'icon24:input'
	 *         })
	 *
	 *     ]
	 * })
	 * export class AppModule {
	 * }
	 * ```
	 *
	 * @example 아이콘, 문구 변경
	 * ```ts
	 * @NgModule({
	 *     imports: [
	 *         TextActModule.forRoot({
	 *         		create: ['icon24:input', '추가']
	 *         })
	 *
	 *     ]
	 * })
	 * export class AppModule {
	 * }
	 * ```
	 *
	 * @param configure
	 */
	static forRoot(configure: Partial<Record<keyof typeof TEXT_ACTINGS, string | [string, string]>>): ModuleWithProviders<TextActModule> {
		return {
			ngModule: TextActModule,
			providers: [
				{
					provide: TEXT_ACT,
					useValue: configure
				}
			]
		}
	}
}